
    import '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/antd-design-x.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-guide-antd-design-x-demo-en-0","docs-guide-antd-design-x-demo-en-1"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/antd-design-x.en.md?type=demo')
};